import { useState, type ReactNode } from 'react'
import { Dialog } from '@radix-ui/themes'
import { AddDataSourceForm } from './AddDataSourceForm'

interface AddDataSourceDialogProps {
  installationId: number
  defaultLoggerMaker: string | null
  defaultSerialNumber: string | null
  defaultPulseWeight: number | null
  defaultDeviceDescription: string
  trigger: ReactNode
}

export const AddDataSourceDialog = ({
  installationId,
  defaultLoggerMaker,
  defaultSerialNumber,
  defaultPulseWeight,
  defaultDeviceDescription,
  trigger
}: AddDataSourceDialogProps) => {
  const [open, setOpen] = useState(false)

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Trigger>{trigger}</Dialog.Trigger>
      <Dialog.Content maxWidth="480px">
        <Dialog.Title>Add data source</Dialog.Title>
        <Dialog.Description size="2" color="gray">
          Create the meter data source for this installation's linked station.
        </Dialog.Description>

        <AddDataSourceForm
          installationId={installationId}
          defaultLoggerMaker={defaultLoggerMaker}
          defaultSerialNumber={defaultSerialNumber}
          defaultPulseWeight={defaultPulseWeight}
          defaultDeviceDescription={defaultDeviceDescription}
          onDone={() => setOpen(false)}
        />
      </Dialog.Content>
    </Dialog.Root>
  )
}
